export default __webpack_public_path__ + "static/media/giftIcon.69eaff90.svg";